__turbopack_context__.v({
  "canvasHost": "lab-scene-module__7gh61q__canvasHost",
  "canvasReady": "lab-scene-module__7gh61q__canvasReady",
  "heroLetterButton": "lab-scene-module__7gh61q__heroLetterButton",
  "moveButton": "lab-scene-module__7gh61q__moveButton",
  "moveIndicator": "lab-scene-module__7gh61q__moveIndicator",
  "poster": "lab-scene-module__7gh61q__poster",
  "posterHidden": "lab-scene-module__7gh61q__posterHidden",
  "scene": "lab-scene-module__7gh61q__scene",
  "srOnly": "lab-scene-module__7gh61q__srOnly",
});
